import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API, authHeaders } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';
import DataTable from '../components/DataTable';

const ACTION_LABEL = {
  activate: 'Активация',
  block: 'Блокировка',
  unblock: 'Разблокировка',
  delete_photo: 'Удаление фото',
  approve_photo_request: 'Одобрение замены фото',
  reject_photo_request: 'Отклонение замены фото',
};

function fmt(str) {
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function StaffActions() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/admin/staff-actions`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  return (
    <Layout>
      <h1 style={ui.title}>Журнал действий персонала</h1>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Кто и когда активировал/заблокировал анкету, удалил фото, одобрил или отклонил заявку на замену фото.
      </p>
      <div style={ui.card}>
        <DataTable
          rows={items}
          rowKey={a => a.id}
          emptyText="Записей пока нет"
          columns={[
            { key: 'actor_name', label: 'Кто', sortValue: a => a.actor_name },
            { key: 'action', label: 'Действие', sortValue: a => ACTION_LABEL[a.action] || a.action, render: a => ACTION_LABEL[a.action] || a.action },
            {
              key: 'target', label: 'Кому', sortValue: a => a.target_user_name || '',
              render: a => a.target_user_id ? (
                <span
                  onClick={(e) => { e.stopPropagation(); navigate(`/applications?open=${a.target_user_id}`); }}
                  style={{ cursor: 'pointer' }}
                >
                  {a.target_user_name || '—'} (id {a.target_user_id})
                </span>
              ) : '—',
            },
            { key: 'detail', label: 'Детали', render: a => a.detail || '—' },
            { key: 'created_at', label: 'Дата', render: a => fmt(a.created_at) },
          ]}
        />
      </div>
    </Layout>
  );
}
